import { createContext, useState } from 'react';

const AccessibilityContext = createContext(null);

const AccessibilityProvider =({children}) => {
    const [contrast, setContrast] = useState(false);
    const [font_Size, setFont_Size] = useState(false);
    
    return (
        <AccessibilityContext.Provider value={{contrast, setContrast, font_Size, setFont_Size}}>
            {children}
        </AccessibilityContext.Provider>
    );
}
export {AccessibilityContext, AccessibilityProvider};